//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('requisition', {
//        templateUrl: 'views/components/views/requisition/requisition.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'requisitionService', function ($stateParams, stateService, translateService, modalService, requisitionService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let requisitionNo = $stateParams.requisition_no;

//            let translations = {
//                confirm_title: '',
//                confirm_cancel_message: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                stockPlaceNameFromButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockget', { stock_keyno: vm.model.edit.stock_keyno_from }) }
//                ],
//                stockPlaceNameToButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockget', { stock_keyno: vm.model.edit.stock_keyno_to }) }
//                ],
//                orderButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderhead', { order_internal_no: vm.model.edit.order_internal_no }) }
//                ],
//                edit: {},
//                lockedSave: false,
//                lockedCancel: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await requisitionService.getSetting({ requisition_no: requisitionNo }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                requisitionService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON CANCEL PROCEDURE FUNCTION CALL

//            vm.cancelValues = function () {
//                vm.model.lockedCancel = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_cancel_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    requisitionService.cancelItem(vm.model.edit).then(function () {
//                        vm.model.lockedCancel = false;
//                        stateService.back();
//                    }, function () {
//                        vm.model.lockedCancel = false;
//                    });
//                }, function () {
//                    vm.model.lockedCancel = false;
//                });
//            };

//            // #endregion BUTTON CANCEL PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    requisitionService.deleteItem(vm.model.edit).then(function () {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
